export default "__VITE_ASSET__DhfWubOv__"